import { Button } from '@components/button';
import { Group } from '@components/layout';
import { InternalLink } from '@components/link';
import { useModal } from '@components/modal';
import { Stack } from '@mui/material';
import { CreateRemoteSessionModal } from '@subsets/profile/CreateRemoteSessionModal';
import { LandingPageHeader } from '../LandingPageHeader';
import { RemoteSessionsTable } from './RemoteSessionsTable';

export const RemoteSessions = () => {
  const { showModal: showCreateModal } = useModal({
    component: CreateRemoteSessionModal,
    modalProps: {
      title: 'Create remote session',
    },
  });

  return (
    <Stack height="100%">
      <LandingPageHeader title="Remote Sessions">
        <Group alignItems="center" gap={2}>
          <InternalLink unstyled to="/profile?tab=keys">
            <Button variant="secondary" sx={{ backgroundColor: 'background.paper' }}>
              Manage SSH keys
            </Button>
          </InternalLink>
          <Button variant="accent" onClick={() => showCreateModal()}>
            Create session
          </Button>
        </Group>
      </LandingPageHeader>
      <RemoteSessionsTable />
    </Stack>
  );
};
